<template>
  <div class="banner">
    {{ message }}
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { bannerMessage } from "@/config";
export default {
  name: "Banner",
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    message() {
      return bannerMessage[this.currencyCode];
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  align-items: center;
  background-color: $color-light;
  color: $color-dark;
  display: flex;
  height: 34px;
  font-size: 12px;
  justify-content: center;
  letter-spacing: 0.65px;
  text-decoration: none;
  padding: 0 5px;

  &__link {
    text-decoration: none;
  }

  @include respond-above(md) {
    height: 36px;
  }
}
</style>
